import { Storybook } from "@tento-ui/ui/storybook";
import { RichChatResponse } from "./rich-chat-response";

const SAMPLE_MARKDOWN = `# Heading 1

## Heading 2

### Heading 3

Here is a paragraph with **bold**, *italic*, and \`inline code\` formatting.

- Bullet one
- Bullet two
- Bullet three

1. First item
2. Second item
3. Third item

> This is a blockquote with some context about the response.

Here is a code block:

\`\`\`typescript
function greet(name: string): string {
  return \`Hello, \${name}!\`;
}
\`\`\`

And a [link to documentation](https://example.com).

Another paragraph to show spacing between elements.`;

export class RichChatResponseStoryBook extends Storybook.Default {
  title(): string {
    return "Rich Chat Response";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Mixed Markdown",
        render: () => {
          const $r = RichChatResponse.make();
          void $r.bind({ markdown: SAMPLE_MARKDOWN });
          return $r;
        },
      },
      {
        title: "Short Reply",
        render: () => {
          const $r = RichChatResponse.make();
          void $r.bind({ markdown: "Sure! The meeting is at **3 PM** today." });
          return $r;
        },
      },
      {
        title: "Code Only",
        render: () => {
          const $r = RichChatResponse.make();
          void $r.bind({
            markdown:
              "Here's the fix:\n\n```rust\nfn main() {\n    println!(\"Hello, world!\");\n}\n```",
          });
          return $r;
        },
      },
    ];
  }
}
